import { createAction } from "@reduxjs/toolkit";

export const SET_CITATIONS_CONTEXT: string = "SET_CITATIONS_CONTEXT";

export const setContext = createAction<any>(SET_CITATIONS_CONTEXT);
